var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-container",
            { staticClass: "grey lighten-4", attrs: { fluid: "", "pa-0": "" } },
            [
              _c(
                "v-row",
                { staticStyle: {}, attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "align-self-center",
                      attrs: { md: "auto", xs: "auto", sm: "auto" }
                    },
                    [
                      _c("crud-button", {
                        attrs: {
                          "x-large": "",
                          color: "blue-grey darken-1",
                          icon: "fa-chevron-left",
                          tooltip: _vm.$t("global.crud.buttons.return")
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.back()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "flex-grow-1 flex-shrink-0 container-data-filter-info",
                      attrs: { cols: "1" }
                    },
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "", "pa-0": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c("v-col", { attrs: { sm: "12", cols: "12" } }, [
                                _c("div", { staticClass: "form-field-name" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "productsTypesClients.productType"
                                        )
                                      ) +
                                      " "
                                  )
                                ]),
                                _c("div", { staticClass: "form-field-value" }, [
                                  _vm._v(" " + _vm._s(_vm.productType) + " ")
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", { attrs: { id: "controlsContainer" } }, [
            _c(
              "div",
              {
                staticClass:
                  "card-title table-controls px-3 d-flex align-center justify-space-between"
              },
              [
                _c(
                  "div",
                  [
                    _c("crud-button", {
                      attrs: {
                        "x-large": "",
                        color: "light-blue lighten-2",
                        icon: "fa-plus",
                        tooltip: _vm.$t("global.crud.button.add")
                      },
                      on: {
                        clicked: function($event) {
                          return _vm.create()
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("div"),
                _c(
                  "div",
                  [
                    _c("crud-button", {
                      attrs: {
                        large: "",
                        color: "blue",
                        icon: "fa-sync-alt",
                        tooltip: _vm.$t("global.crud.buttons.refreshTable")
                      },
                      on: {
                        clicked: function($event) {
                          return _vm.refreshItemsView()
                        }
                      }
                    }),
                    _c("ExportExcel", {
                      attrs: {
                        url: "/productsTypesClients",
                        filter: this.filter
                      }
                    }),
                    _c("ImportExcel", {
                      attrs: { url: "/productsTypesClients" },
                      on: { done: _vm.search }
                    })
                  ],
                  1
                )
              ]
            )
          ]),
          _c(
            "div",
            { attrs: { id: "dataContainer" } },
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.items,
                  options: _vm.options,
                  page: _vm.pagination.page,
                  "server-items-length": _vm.pagination.totalItems,
                  "no-results-text": _vm.$t(
                    "global.datatable.noMatchingResults"
                  ),
                  "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
                  "footer-props": {
                    "items-per-page-options": _vm.rowsPerPageItems,
                    "show-first-last-page": true,
                    "show-current-page": true
                  },
                  loading: _vm.loading,
                  light: "",
                  "multi-sort": "",
                  dense: ""
                },
                on: {
                  "update:options": function($event) {
                    _vm.options = $event
                  },
                  "update:page": function($event) {
                    return _vm.$set(_vm.pagination, "page", $event)
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "body",
                    fn: function(ref) {
                      var items = ref.items
                      return [
                        _c(
                          "tbody",
                          _vm._l(items, function(item) {
                            return _c("tr", { key: item.code }, [
                              _c(
                                "td",
                                [
                                  _c("crud-button", {
                                    attrs: {
                                      "x-small": "",
                                      color: "orange",
                                      icon: "fa-pen",
                                      tooltip: _vm.$t(
                                        "global.crud.buttons.edit"
                                      )
                                    },
                                    on: {
                                      clicked: function($event) {
                                        return _vm.edit(
                                          item.clientCode +
                                            "/" +
                                            item.productTypeCode
                                        )
                                      }
                                    }
                                  }),
                                  item.deletionDate === undefined ||
                                  item.deletionDate === null
                                    ? _c("crud-button", {
                                        attrs: {
                                          "x-small": "",
                                          color: "red",
                                          icon: "fa-trash",
                                          tooltip: _vm.$t(
                                            "global.crud.buttons.delete"
                                          )
                                        },
                                        on: {
                                          clicked: function($event) {
                                            return _vm.suspend(
                                              item.clientCode +
                                                "/" +
                                                item.productTypeCode
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c("td", [_vm._v(_vm._s(item.clientCode))]),
                              _c("td", [_vm._v(_vm._s(item.volumeLimit))]),
                              _c("td", [_vm._v(_vm._s(item.weightLimit))]),
                              _c("td", [_vm._v(_vm._s(item.price))]),
                              _c("td", [_vm._v(_vm._s(item.priceOver))])
                            ])
                          }),
                          0
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "600",
            persistent: "",
            "no-click-animation": ""
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("validation-observer", {
            ref: "obs",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var invalid = ref.invalid
                  var validated = ref.validated
                  var passes = ref.passes
                  return [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              dark: "",
                              color: "primary",
                              dense: "",
                              flat: ""
                            }
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              { staticClass: "white--text" },
                              [_vm._v(" " + _vm._s(_vm.formTitle) + " ")]
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("fas fa-times")])],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          { staticClass: "details-list" },
                          [
                            _c(
                              "v-form",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t(
                                              "productsTypesClients.productType"
                                            ),
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.productType,
                                            callback: function($$v) {
                                              _vm.productType = $$v
                                            },
                                            expression: "productType"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        !_vm.editMode
                                          ? _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "productsTypesClients.client"
                                                ),
                                                rules: "required"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            items:
                                                              _vm.clientsItems,
                                                            loading:
                                                              _vm.clients
                                                                .isLoading,
                                                            "search-input":
                                                              _vm.clients
                                                                .search,
                                                            "hide-no-data": "",
                                                            "no-data-text": _vm.$t(
                                                              "global.autocomplete.noDataFound"
                                                            ),
                                                            "item-text":
                                                              "description",
                                                            "item-value":
                                                              "code",
                                                            label: _vm.$t(
                                                              "productsTypesClients.client"
                                                            ),
                                                            placeholder: _vm.$t(
                                                              "global.autocomplete.starTypingToSearch"
                                                            ),
                                                            "error-messages": errors,
                                                            clearable: ""
                                                          },
                                                          on: {
                                                            "update:searchInput": function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.clients,
                                                                "search",
                                                                $event
                                                              )
                                                            },
                                                            "update:search-input": function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.clients,
                                                                "search",
                                                                $event
                                                              )
                                                            },
                                                            focus: function(
                                                              $event
                                                            ) {
                                                              _vm.clients.isEdit = true
                                                            },
                                                            change: function(
                                                              $event
                                                            ) {
                                                              _vm.clients.isEdit = false
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.item
                                                                .clientCode,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.item,
                                                                "clientCode",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.clientCode"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          : _c("v-text-field", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "productsTypesClients.client"
                                                ),
                                                disabled: ""
                                              },
                                              model: {
                                                value: _vm.item.clientCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "clientCode",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.clientCode"
                                              }
                                            })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm6" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "productsTypes.volumeLimit"
                                            ),
                                            rules: "decimal:5,4"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "productsTypes.volumeLimit"
                                                        ),
                                                        type: "decimal",
                                                        "error-messages": errors
                                                      },
                                                      on: {
                                                        keypress: function(
                                                          $event
                                                        ) {
                                                          return _vm.decimalOnlyField(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.item.volumeLimit,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "volumeLimit",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.volumeLimit"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm6" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "productsTypes.weightLimit"
                                            ),
                                            rules: "decimal:7,4"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "productsTypes.weightLimit"
                                                        ),
                                                        type: "decimal",
                                                        "error-messages": errors
                                                      },
                                                      on: {
                                                        keypress: function(
                                                          $event
                                                        ) {
                                                          return _vm.decimalOnlyField(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.item.weightLimit,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "weightLimit",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.weightLimit"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm6" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("productsTypes.price"),
                                            rules: "decimal:5,2"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "productsTypes.price"
                                                        ),
                                                        type: "decimal",
                                                        "error-messages": errors
                                                      },
                                                      on: {
                                                        keypress: function(
                                                          $event
                                                        ) {
                                                          return _vm.decimalOnlyField(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: _vm.item.price,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "price",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.price"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm6" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "productsTypes.priceOver"
                                            ),
                                            rules: "decimal:5,2"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "productsTypes.priceOver"
                                                        ),
                                                        type: "decimal",
                                                        "error-messages": errors
                                                      },
                                                      on: {
                                                        keypress: function(
                                                          $event
                                                        ) {
                                                          return _vm.decimalOnlyField(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.item.priceOver,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "priceOver",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.priceOver"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "black", text: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("global.buttons.close")) +
                                    " "
                                )
                              ]
                            ),
                            _vm.editMode
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "orange", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.update)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.update")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "green", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.save)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.create")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }